import fetch from "../auth/FetchInterceptor";

const ProofService = {};

ProofService.submitProof = function (formData) {
  return fetch.post('api/agent/submitPaymentProof', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export default ProofService;
